import { isAmazonUrl } from './buying.js';

export const affiliateDisclosure = 'Affiliate link, we may earn a commission if you buy through this link, at no extra cost to you';

// Recognise common supplied tracking links. Custom links can instead use the
// server's AFFILIATE_DISCLOSURE_ENABLED setting; URLs alone cannot identify every deal.
const trackingDomains = [
  'anrdoezrs.net', 'jdoqocy.com', 'kqzyfj.com', 'tkqlhce.com', 'dpbolvw.net',
  'commission-junction.com', 'emjcd.com', 'qksrv.net',
  'awin1.com', 'tidd.ly', 'ds1.nl', 'daisycon.io', 'prf.hn', 'linksynergy.com',
];
// An editor's own answer settles what a URL cannot: a recorded commission arrangement is disclosed
// even when the destination carries no recognisable tracking.
export const offerIsAffiliate = (offer: { affiliate?: boolean; url: string }) =>
  Boolean(offer.affiliate) || isAffiliateLink(offer.url);
// Tracking the server adds at the moment of the click, which a stored URL cannot show: Amazon tags for the
// marketplaces that have one (`amazonHosts`, matched exactly as affiliateUrl matches them) and Rakuten deep
// links for configured storefronts. An Amazon marketplace without a tag is not disclosed, because its links
// earn nothing. `all` is the AFFILIATE_DISCLOSURE_ENABLED override; a plain `true` means every link.
export type ClickTimeAffiliates = { all?: boolean; amazonHosts?: string[]; hosts?: string[] };
export const clickTimeAffiliates = (value: boolean | ClickTimeAffiliates | undefined): ClickTimeAffiliates =>
  typeof value === 'boolean' ? { all: value } : (value ?? {});
export function earnsCommission(url: string, config: ClickTimeAffiliates, recorded = false) {
  if (recorded || config.all || isAffiliateLink(url)) return true;
  try {
    const host = new URL(url).hostname.toLowerCase();
    return Boolean(config.amazonHosts?.includes(host)) || Boolean(config.hosts?.includes(host.replace(/^www\./, '')));
  } catch {
    return false;
  }
}
export function isAffiliateLink(value: string): boolean {
  try {
    const url = new URL(value);
    if (!['http:', 'https:'].includes(url.protocol)) return false;
    const host = url.hostname.toLowerCase();
    if (trackingDomains.some(domain => host === domain || host.endsWith('.' + domain))) return true;
    if (host === 'amzn.to') return true; // Short destination cannot be inspected here; disclose conservatively.
    if (isAmazonUrl(value) && Boolean(url.searchParams.get('tag'))) return true;
    return ['cjevent', 'aff', 'affid', 'aff_id', 'affiliate', 'affiliate_id', 'ref', 'referral'].some(
      key => Boolean(url.searchParams.get(key)),
    );
  } catch {
    return false;
  }
}
